<section class="hero is-dark ">
    <div class="hero-head">
        <nav class="navbar">
            <div class="navbar-brand">

                <a class="navbar-item" routerLink="/dashboard" routerLinkActive="active">
                    <figure class="image is-24x24" style="">
                        <img class="is-rounded" [src]="configuracion.empresa.logo ? API_PATH+'/adjunto/configuracion/'+configuracion.empresa.logo : './assets/yoursoft.png'" alt="Logo">
                    </figure>

                </a>
                <a class="navbar-item" routerLink="/{{menuactual}}" routerLinkActive="active">
                    <span class="icon fa-2x">
                        <i class="{{menuicono}}">&nbsp;</i>
                    </span> &nbsp;
                    <h1 class="title">&nbsp;{{menutitulo}}</h1>
                </a>
                <span class="navbar-burger burger" [ngClass]="{'is-active': activar}" data-target="navbarMenuHeroA" (click)="actilet = !activar">
                    <span></span>
                <span></span>
                <span></span>
                </span>
            </div>
            <div id="navbarMenuHeroA" class="navbar-menu" [ngClass]="{'is-active': activar}">
                <div class="navbar-end">
                    <a class="navbar-item is-active">
                        <span class="nav-item is-hidden-mobile " style="font-size: calc(100vw - 98.9vw);">
                            {{configuracion.empresa?.nombre }} &nbsp;
                            <span class="icon">
                                <i class="icon-next-2"></i>
                            </span> &nbsp; Campus: {{configuracion.sucursal?.nombre}}

                        <span class="icon">
                              <i class="icon-next-2"></i>
                            </span> &nbsp;{{configuracion.nivel_educativo?.nombre}}
                        </span>

                    </a>
                    <a class="navbar-item tooltip" id="cambiar_empresa" (click)="toggleCambiarEmpresa()">
                        <span class="icon fa-2x">
                            <i class="icon-building"></i>
                        </span>
                        <span class="tooltiptext">Cambiar de empresa</span>
                    </a>
                    <a class="navbar-item is-hidden-tablet tooltip" (click)="toggleMenuAside()">
                        <span class="icon fa-2x">
                            <i class="fa fa-navicon"></i>
                        </span>
                        <span class="tooltiptext">Menú Opciones</span>
                    </a>
                    <a class="navbar-item tooltip" (click)="hub.toggle()">
                        <span class="icon fa-2x has-text-warning">
                            <i class="icon-home"></i>
                        </span>
                        <span class="tooltiptext">Menú Modulos</span>
                    </a>

                    <a class="navbar-item tooltip" (click)="toggleManual()">
                        <span class="icon fa-2x has-text-info">
                            <i class="icon-book"></i>
                        </span>
                        <span class="tooltiptext">Manual de Usuario</span>
                    </a>

                    <a class="navbar-item is-hidden-mobile tooltip" (click)="perfil.toggle()">

                        <figure class="image" style="width:26px;">
                            <img [src]="usuario.foto ? API_PATH+'/adjunto/usuario/'+usuario.foto : usuario.avatar ?  usuario.avatar : './assets/128x128.png'" alt="Image" class="profile">
                        </figure>
                        &nbsp;
                        <span>{{ usuario?.nombre | splitFirst }}</span>
                        <span class="tooltiptext">Perfil</span>
                    </a>
                    <a class="navbar-item is-hidden-tablet tooltip" (click)="perfil.toggle()">

                        <figure style="width:26px;">
                            <img class="is-rounded" [src]="usuario.foto ? API_PATH+'/adjunto/usuario/'+usuario.foto : usuario.avatar ?  usuario.avatar : './assets/128x128.png'" alt="Image" class="profile">
                        </figure>
                        <span class="tooltiptext">Perfil</span>
                    </a>
                </div>
            </div>
        </nav>
    </div>
</section>


<app-hub #hub></app-hub>
<app-perfil #perfil></app-perfil>


<div class="modal" [ngClass]="{'is-active': mostrarMenuAside}">
    <div class="modal-background" (click)="toggleMenuAside()"></div>
    <div class="modal-content">
        <div class="card" style="width: 100%">
            <div class="card-content">
                <app-sistema-menu-aside></app-sistema-menu-aside>
            </div>
        </div>
    </div>
    <button class="modal-close" (click)="toggleMenuAside()"></button>
</div>

<div class="modal" [ngClass]="{'is-active': mostrarCambiarEmpresa}">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Cambiar Empresa y/o Campus
            </p>
            <button class="delete" (click)="toggleCambiarEmpresa()"></button>
        </header>
        <section class="modal-card-body">
            <div class="notification is-warning" *ngIf="mensaje_cambiar_empresa != ''">
                {{mensaje_cambiar_empresa}}
            </div>
            <nav class="panel" *ngFor="let val of usuario.empresas; let i = index;" style="margin-bottom: 0px">
                <div class="panel-heading">
                    <div class="field">
                        <div class="b-checkbox is-info">
                            <input id="{{val.id}}" class="styled" type="radio" [checked]="empresa == val.id" (click)="mostrar[val.id] = !mostrar[val.id]">
                            <label for="{{val.id}}">
                                {{val.nombre}}
                            </label>
                        </div>
                    </div>
                </div>
                <label class="panel-block" *ngFor="let item of val.sucursales; let i2 = index;" [style.display]="mostrar[val.id] ? '': 'none'">
                    <div class="field">
                        <div class="b-checkbox is-info">
                            <input id="{{item.id}}" class="styled" [checked]="sucursal == item.id" (click)="cambiar_sucursal(val, item)" type="radio">
                            <label for="{{item.id}}">
                                {{item.nombre}}
                            </label>
    </div>
</div>

</label>
</nav>
<br>
<fieldset id="nivel" align="center">
    <legend>Seleccione el nivel educativo</legend>

    <a class="button" [ngClass]="nivel_educativo == item.id ? 'is-active is-success' : 'is-link'" *ngFor="let item of usuario.niveles_educativos; let i = index;" (click)="cambiar_nivel_educativo(item)">{{item.nombre}}</a>
</fieldset>

</section>
<footer class="modal-card-foot">
    <a class="button" (click)="toggleCambiarEmpresa()">Cancelar</a>
</footer>
</div>
</div>

<div class="modal" [ngClass]="{'is-active': mostrarManual}">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Manual de usuario
            </p>
            <button class="delete" (click)="toggleManual()"></button>
        </header>
        <section class="modal-card-body">
            <object [data]="API_PATH+'/adjunto/manual/v3.pdf' | safe" width="650" height="450" type='application/pdf'>
                <p>Disculpas, el archivo no puede ser visualizado en tu navegador :(</p>
                <a [href]="API_PATH+'/adjunto/manual/v3.pdf' | safe" target="_blank">Click para ver en otra pestaña</a>
            </object>

        </section>
        <footer class="modal-card-foot">
            <a class="button is-warning" (click)="toggleManual()">Cerrar</a>
            <a class="button is-success" [href]="API_PATH+'/adjunto/manual/v1.pdf' | safe" target="_blank">Abrir en otra pestaña</a>
        </footer>
    </div>
</div>